<template lang="pug">
	modal(:max-width="1600")
		.card.text-left
			.card-header.bg-info
				span.fa.fa-table.mr-2
				| Rotación vertical
				button.close(@click="cerrar") &times;
			.card-body.bg-light
				.row
					.col
						.input-group.input-group-sm
							.input-group-prepend
								.input-group-text Acción
							select.form-control.form-control-sm(v-model="Accion")
								option(value="reemplazar") Reemplazar inserciones
								option(value="agregar") Agregar inserciones
					.col
						.input-group.input-group-sm
							.input-group-prepend
								.input-group-text Fechas
							input.form-control.form-control-sm(:disabled="true", :value="dias.length + ' dias seleccionados'")
							.input-group-append
								button.btn.btn-sm.btn-primary(@click="verSeleccionarFechas = true")
									span.fa.fa-calendar
					.col.text-right
						button.btn.btn-sm.btn-warning(@click="verSeleccionFicheros = true")
							span.fa.fa-plus.mr-2
							| Agregar ficheros
				
			table.table.table-striped.m-0
				thead
					tr
						th.p-1.bg-dark.text-white
							span.fa.fa-table.mr-2
							| Ficheros
				tbody
					tr(
						v-for="fichero in listadoFicheros"
						:key="fichero.FicheroID"
					)
						td.p-1(
							@dblclick="insertar(fichero)"
							@click="seleccionado = fichero"
							:class="seleccionado === fichero ? 'bg-info text-white' : ''"
							style="cursor: default;user-select: none;text-align:left;"
						) {{fichero.FicheroID}} - {{ fichero.Descripcion }}
			.contieneRotacion
				.originales
					.tabla
						table.table.table-striped
							thead.bg-dark.text-white
								tr
									th.p-1
										span.fa.fa-list.mr-2
										| Originales
							tbody
								tr(
									v-for="(fichero, i) in ficheros"
									:key="i"
									@dblclick="delFichero(i)"
									@click="ficheroFoco = i"
									:class="ficheroFoco === i ? 'bg-warning' : ''"
								)
									td.p-1.celdaFichero(style="text-align:left;") {{fichero.FicheroID}} - {{fichero.Descripcion}}
				.inserciones
					table.table.table-hover.m-0
						thead.bg-dark.text-white
							tr
								th.text-right.p-1 Ins
								th.text-right.p-1 Ref ext.
								th.text-right.p-1 Hora Ini.
								th.text-right.p-1 Hora Fin
								th.text-right.p-1 Importe
								th.text-right.p-1 Descuento
								th.text-right.p-1 Recargo
								th.text-right.p-1 Contenido
								th.text-right.p-1 Programa
								th.text-right.p-1 Importe final
								th.text-right.p-1.text-right
									button.btn.btn-sm.btn-warning(@click="addInsercion", style="width:15px;height:15px;font-size:0.8em;padding: 1px; padding-left: 2px;")
										span.fa.fa-plus
						tbody
							tr(
								v-for="(insercion, i) in inserciones"
								:key="i"
								:class="insercionSel === i ? 'activa' : ''"
								@click="insercionSel = i"
								@dblclick="verColocacion = true"
							)
								td.celdaInsercion.p-1
									input.input(v-model.number="inserciones[i].Inserciones", placeholder="0", size="2")
								td.celdaInsercion.p-1
									input.input(v-model="inserciones[i].RefExterna")
								td.celdaInsercion.p-1 {{ insercion.HoraInicio }}
								td.celdaInsercion.p-1 {{ insercion.HoraFin }}
								td.celdaInsercion.p-1
									input.input(v-model.number="inserciones[i].Importe", @keyup="calculaImporte")
								td.celdaInsercion.p-1
									input.input(v-model.number="inserciones[i].Descuento", @keyup="calculaImporte")
								td.celdaInsercion.p-1
									input.input(v-model.number="inserciones[i].Recargo", @keyup="calculaImporte")
								td.celdaInsercion.p-1 {{ insercion.ContenidoNombre }}
								td.celdaInsercion.p-1 {{ insercion.ProgramaNombre }}
								td.celdaInsercion.p-1 {{ insercion.ImporteFinal | currency('') }} €
								td.celdaInsercion.p-1.text-right
									button.btn.btn-sm.btn-danger(@click="delInsercion(i)")
										span.fa.fa-trash
			.card-footer
				button.btn.btn-primary.btn-sm(@click="aplicar")
					span.fa.fa-check.mr-2
					| Aplicar
			
		ModalSeleccionFicheros(
			:ClienteID="contrato.ClienteID",
			v-if="verSeleccionFicheros",
			@cerrar="verSeleccionFicheros = false",
			@seleccionar="addFicheros($event)"
		)
		modal(v-if="verSeleccionarFechas")
			.card
				.card-header
					button.close(@click="verSeleccionarFechas = false") &times;
				.card-body
					CalendarioAnual(:from="contrato.FechaInicio", :to="contrato.FechaFin", :seleccion.sync="dias")
		ModalColocacion(v-if="verColocacion", @cerrar="verColocacion = false", :EmisoraID="linea.EmisoraID", @colocacion="setColocacion($event)")
</template>
<script>
import ModalSeleccionFicheros from '../utilidades/modalSeleccionOriginal.component.vue'
import CalendarioAnual from '../../../../../gestion-emisoras/vue/componentes/utilidades/calendario-anual.vue'
import ModalColocacion from '../colocacion/colocacion.vue'
import Servicios from '../../../servicios'

export default {
	props: ['contrato', 'linea'],
	components: {
		ModalSeleccionFicheros,
		CalendarioAnual,
		ModalColocacion
	},
	data () {
		return {
			Accion: 'reemplazar',
			ficheros: [],
			ficheroFoco: null,
			dias: [],
			inserciones: [],
			insercionSel: null,
			reemplazar: true,
			verSeleccionFicheros: false,
			listadoFicheros: [],
			seleccionado: null,
			verSeleccionarFechas: false,
			verColocacion: false
		}
	},
	methods: {
		addFicheros (e) {
			e.forEach(fichero => {
				let existe = false
				for (let i = 0; i < this.listadoFicheros.length; i++) {
					if (this.listadoFicheros[i].FicheroID === fichero.FicheroID) {
						existe = true
					}
				}

				if (!existe) {
					this.listadoFicheros.push(fichero)
				}
			})
		},
		delFichero (i) {
			this.ficheros.splice(i, 1)
			this.ficheroFoco = null
		},
		addInsercion () {
			this.inserciones.push({
				Inserciones: null,
				RefExterna: null,
				DuracionReal: null,
				HoraInicio: '00:00:00',
				HoraFin: '00:00:00',
				ContenidoID: null,
				ContenidoNombre: null,
				ProgramaID: null,
				ProgramaNombre: null,
				Fijar: null,
				Importe: null,
				Descuento: null,
				Recargo: null,
				ImporteFinal: null
			})
			this.calculaImporte()
		},
		delInsercion (i) {
			this.inserciones.splice(i, 1)
			this.insercionSel = null
		},
		setColocacion (datos) {
			this.inserciones[this.insercionSel] = {...this.inserciones[this.insercionSel], ...datos}
		},
		insertar (fichero) {
			this.ficheros.push(fichero)
		},
		calculaImporte () {
			this.inserciones = this.inserciones.map(i => {
				const importe = typeof i.Importe === 'number' ? i.Importe : 0
				let importeFinal = importe
				if (typeof i.Descuento === 'number' && importe !== 0) {
					importeFinal = importe - (importe * i.Descuento / 100)
				}

				if (typeof i.Recargo === 'number') {
					importeFinal = importeFinal + i.Recargo
				}

				i.ImporteFinal = importeFinal
				return i
			})
		},
		aplicar () {
			// Revisamos que hay al menos un día seleccionado
			if (this.dias.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día')
				return
			}

			if (this.ficheros.length === 0) {
				this.$error('Error', 'Debes insertar al menos un fichero en originales')
				return
			}

			if (this.inserciones.length === 0) {
				this.$error('Error', 'No has definido ninguna inserción')
				return
			}

			// Ahora repasamos cada inserción
			for (let i = 0; i < this.inserciones.length; i++) {
				const ins = this.inserciones[i]

				if (!ins.Inserciones || ins.inserciones <= 0) {
					this.$error('Error', `La línea ${i + 1} no tiene un número de inserciones válido`)
					return
				}

				const exp = /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/

				if (!exp.test(ins.HoraInicio)) {
					this.$error('Error', `La hora de inicio de la línea ${i + 1} no es válida`)
					return
				}

				if (!exp.test(ins.HoraFin)) {
					this.$error('Error', `La hora de fin de la línea ${i + 1} no es válida`)
					return
				}

				const horaInicio = ins.HoraInicio.split(':').map(d => parseInt(d))
				const horaFin = ins.HoraFin.split(':').map(d => parseInt(d))

				if (horaInicio[0] > horaFin[0]) {
					this.$error('Error', `En la línea ${i + 1} la hora de inicio es posterior a la de fin`)
					return
				} else if (horaInicio[0] === horaFin[0] && horaInicio[1] > horaFin[1]) {
					this.$error('Error', `En la línea ${i + 1} la hora de inicio es posterior a la de fin`)
					return
				} else if (horaInicio[0] === horaFin[0] && horaInicio[1] > horaFin[1] && horaInicio[2] > horaFin[2]) {
					this.$error('Error', `En la línea ${i + 1} la hora de inicio es posterior a la de fin`)
					return
				}
			}

			// Ahora mapeamos los datos
			let ins = JSON.parse(JSON.stringify(this.linea.inserciones))

			// En caso de que sea sustitució, quitamos las de los días seleccionados
			const diasSeleccionados = this.dias.map(d => {
				return this.$moment(d).format('YYYY-MM-DD')
			})

			if (this.Accion === 'reemplazar') {
				ins = ins.filter(i => {
					return (diasSeleccionados.indexOf(i.Dia) < 0)
				})
			}

			// Ahora empezamos con la rotación
			let indiceFichero = 0
			for (let d = 0; d < this.dias.length; d++) {
				for (let l = 0; l < this.inserciones.length; l++) {
					const linea = this.inserciones[l]

					for (let i = 0; i < linea.Inserciones; i++) {
						const fichero = (indiceFichero < this.ficheros.length) ? indiceFichero : indiceFichero % this.ficheros.length
						// Generamos la inserción para este día, está línea y ese fichero
						const nuevaInsercion = Servicios.NuevaInsercion(this.$moment(this.dias[d]).format('YYYY-MM-DD'))
						nuevaInsercion.FicheroID = this.ficheros[fichero].FicheroID
						nuevaInsercion.Descripcion = this.ficheros[fichero].Descripcion
						nuevaInsercion.DuracionReal = this.ficheros[fichero].Duracion
						nuevaInsercion.HoraInicio = linea.HoraInicio
						nuevaInsercion.HoraFin = linea.HoraFin
						nuevaInsercion.ProgramaID = linea.ProgramaID
						nuevaInsercion.ProgramaNombre = linea.ProgramaNombre
						nuevaInsercion.ContenidoID = linea.ContenidoID
						nuevaInsercion.ContenidoNombre = linea.ContenidoNombre
						nuevaInsercion.Fijar = linea.Fijar

						// TODO: faltan parámetros
						ins.push(nuevaInsercion)
						indiceFichero++
					}
				}
			}
			this.$emit('rotacion', ins)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.contieneRotacion {
	border-top: 2px solid #e0e0e0;
	display: flex;
	width: 100%;
	flex-direction: row;
	height: 500px;
}
.originales {
	border-right: 1px solid #e0e0e0;
	background-color: #f9f9f9;
	flex-basis: 200px;
	flex-grow: 0;
	flex-shrink: 0;
	height: 500px;
}

.originales > .tabla {
	max-height: 470px;
	overflow: auto;
}

.celdaFichero {
	cursor: default;
	user-select: none;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 190px;
}
.inserciones {
	flex-grow: 1;
	flex-basis: 1;
}

.celdaInsercion {
	cursor: default;
	user-select: none;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 190px;
}

tr.activa {
	background-color: #e0e0e0 !important;
}

td {
	text-align: right;
}

.input {
	border: 0;
	padding: 2px;
	margin: 0;
	text-align: right;
	background-color: rgba(0,0,0,0);
	border-bottom: 1px dotted #444444;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/rotacion-vertical/rotacion-vertical.vue